export const mezoUSD = '0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186';
export const mUSDC = '0x04671C72Aab5AC02A03c1098314b1BB6B560c197';
export const mUSDT = '0xeB5a5d39dE4Ea42C2Aa6A57EcA2894376683bB8E';
